import { useRootSelector } from "./useAppSelector";
import Api from "../api";
import { useEffect } from "react";
import { unblockFdbLicense } from "../features/slices/rootSlice";
import { useDispatch } from "react-redux";
export const shouldShowFdbLicenseCheck = (rootState) => {
    const fdbLicenseStatus = rootState.installationInfo.fdbLicenseStatus;
    return (!fdbLicenseStatus.checksumMatches
        || fdbLicenseStatus.daysTillFdbLicenseExpiration < 30)
        && !fdbLicenseStatus.fdbLicenseUnblocked
        && !rootState.headlessLoginResult;
};
export const useCheckFdbLicense = () => {
    const rootState = useRootSelector();
    const dispatch = useDispatch();
    useEffect(() => {
        const fdbLicenseStatus = rootState.installationInfo.fdbLicenseStatus;
        if (!shouldShowFdbLicenseCheck(rootState))
            return;
        if (!fdbLicenseStatus.checksumMatches) {
            window.DialogManager.GlobalDialog.show({
                title: "FDB License broken",
                body: "Your First Data Bank License is missing or broken. Please contact Technical Support.",
                hideCloseButton: true,
            });
        }
        else if (fdbLicenseStatus.daysTillFdbLicenseExpiration < 0) {
            var dayOfWeek = new Date().toLocaleString("en-US", {
                weekday: "short",
            });
            if (dayOfWeek !== "Sat" && dayOfWeek !== "Sun") {
                window.DialogManager.GlobalDialog.showForm("Your First Data Bank license has expired. Please enter a temporary password or contact your System Administrator.", [
                    {
                        name: "temporaryPassword",
                        label: "Temporary password: ",
                        required: true,
                        value: "",
                    },
                ], {
                    hideCloseButton: true,
                    buttons: {
                        CONFIRM: {
                            label: "Submit",
                            type: "success",
                            keyCode: 13,
                            callback: function (formData, dialog) {
                                if (!formData.fields.temporaryPassword ||
                                    formData.fields.temporaryPassword.length !== 4) {
                                    dialog.showMessage("Invalid temporary password.");
                                }
                                else {
                                    Api.checkFdbLicenseTemporaryPassword(formData.fields.temporaryPassword)
                                        .then((result) => {
                                        if (result.data.passwordValid) {
                                            dialog.hide();
                                            dispatch(unblockFdbLicense());
                                        }
                                        else {
                                            dialog.showMessage("Invalid temporary password.");
                                        }
                                    })
                                        .catch(() => { });
                                }
                            },
                        },
                    },
                });
            }
            else {
                window.DialogManager.GlobalDialog.show({
                    title: "FDB License expired",
                    body: "Your First Data Bank license has expired. Please contact your System Administrator.",
                    hideCloseButton: true,
                    buttons: {
                        OK: {
                            label: "OK",
                            type: "success",
                            focus: true
                        },
                    },
                });
            }
        }
        else if (fdbLicenseStatus.daysTillFdbLicenseExpiration < 30) {
            window.DialogManager.GlobalDialog.show({
                title: "FDB License",
                body: `Your First Data Bank license is due to expire in ${fdbLicenseStatus.daysTillFdbLicenseExpiration} days on ${fdbLicenseStatus.prhAllFDBLicense}. The system will be unavailable after that date unless the license has been renewed.`,
                hideCloseButton: true,
                buttons: {
                    OK: {
                        label: "OK",
                        type: "success",
                        focus: true,
                        callback: () => {
                            dispatch(unblockFdbLicense());
                        }
                    },
                },
            });
        }
        ;
    }, [rootState.installationInfo.fdbLicenseStatus]);
};
